import { useState } from "react";
import "../../assets/css/BatteryStation/batteryStation.css";

const makerNameFormatter = (stationName = "") => {
  //CASES : BATT_05, BATT.04, BATTERY_CHARGHER_04, LIT_BATT_04, BATT 05, BATT 10
  if (stationName) {
    const batteryStation = stationName.replace(/[\s.]/g, "_");
    let markerNotation = batteryStation[0];
    const stationNumber = batteryStation.split("_").reverse()[0];

    if (markerNotation === "L") markerNotation += "B";

    return markerNotation + stationNumber;
  }
};

const BatteryStationObject = ({ stationData, index }) => {
  const stationNameText = makerNameFormatter(stationData.stationName) || "";

  const statusColor =
    stationData.status === "Enabled"
      ? "#238749"
      : stationData.status === "Disabled"
      ? "#FFC0CB"
      : "#1839E0";

  const [isBatteryStationPopupOpen, setIsBatteryStationPopupOpen] =
    useState(false);

  const openModal = () => {
    setIsBatteryStationPopupOpen(!isBatteryStationPopupOpen);
    document.body.classList.add("prevent-scroll");
  };

  return (
    <div
      key={index}
      onClick={() => openModal(index)}
      className="batt-station-container"
      style={{
        backgroundColor: statusColor,
      }}
    >
      <span className="battery-station-name-text">{stationNameText}</span>
    </div>
  );
};

export default BatteryStationObject;
